const ru = {
  greatJobTxt: 'Отличная работа!',
  greatJobFor100: 'Вау! Это было очень круто!',
  pointsTxt: 'очков',
  failedQuestions: 'Ваши не правильные ответы',
  passedQuestion: 'Ваши правильные ответы',
  recommendationTxt: 'Рекомендуется к прочтению',
  reminderTxt: 'Создать напоминание',
  nextTestTxt: 'Следующий тест доступен через',
  startBtn: 'Начать Тест',
  finalTest: 'Финальный Тест',
  continueTest: 'Продолжить Тест',
  done: 'Готово',
  insight: 'Истинные знания требуют терпения и дисциплины.',
  achievementUnlocked: 'Достижение разблокировано!',
  clickMe: 'Нажми Сюда! ^_^',
  passedFinalTest: 'У вас получилось!!!',
  passedFinalTestSubtext:
    'Вы разблокировали эндгейм. Получайте уникальные награды пока улучшаете свои знания каждый день!',
  failedFinalTest: ' Не удалось.',
  failedFinalTestSubtext:
    'Попробуйте снова завтра. Сертификат завершения того стоит! ',
  encouragement: 'Ознакомьтесь с рекомендуемым материалом 🌻',
  betterLuckNextTime: 'У вас все впереди!',
  testIsAvailable: 'ДОСТУПНО СЕЙЧАС!',
  pleaseRateFirstWord: 'Пожалуйста',
  pleaseRate: 'оцените ваш опыт',
  levelUp: 'Повышение уровня!',
  calculatingTitle: 'Калькуляция результатов',
  analyzingAnswers: 'Анализируем ваши ответы',
  consultingWithBob: 'Консультируемся с Бобом GPT',
  achievementProgress: 'Проверка прогресса достижений',
  recommendedReading: 'Генерация рекомендуемых материалов',
};
export default ru;
